export const css = {
	root: '_2td-yQ6e',
	videoInstructions: 'vfaX2_eg',
	videoWrapper: '_39RXtCx2',
	videoTranscript: '_3R8AsStZ',
	' _key': 'ascm-theme/ascm/video/video'
};

export default css;
